import styled, { css } from 'styled-components'
import { MEDIA } from 'utils/constants'
import { Card, Checkbox } from 'components/forms'
import ChevronRight from 'static/icons/chevron-right_circle.svg'
import { assetPrefix } from 'config/env_config'

// Media query
const { DESKTOP_UP, MOBILE } = MEDIA

export const ServiceCard = styled(Card)`
    margin-bottom: 0;
    height: auto;
    gap: 0;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
  
   ${({ isServicePackage }) => isServicePackage && css`
     margin-bottom: 0;
     height: auto;

     @media screen and (max-width: 1200px) {
       max-width: 100%;
       display: flex;
       flex-direction: row;
       justify-content: space-between;
       align-items: center;
       padding: 16px;
     }

     @media screen and ${DESKTOP_UP} {
       width: 152px;
       min-height: 186px;
       padding: 16px 16px 27px;

       > div {
           display: flex;
           flex-direction: column;
           align-items: center;
           justify-content: flex-start;
           height: 100%;
       }
     }

     @media screen and ${MOBILE} {
       flex-direction: column;
       padding: 16px 8px 24px 8px;
       width: 141px;
     }

   `}
`

export const Pet = styled(Card)`
  width: 116.67px;
  height: 145px;
  text-align: center;
  align-items: center;
  background: ${props => props.selected ? 'var(--Color-Primary-color-primary-50, #D8EEF6)' : 'var(--Color-Neutral-Basic-color-neutral-white, #FFF)'};
  padding: 16px;
  border-radius: 24px;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 83px;
  }

   @media screen and (max-width: 600px) {
    width: 140px;
  }

   @media screen and (max-width: 375px) {
    width: 103.67px;
  }
`

export const WrapperPetPhoto = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  align-items: center;
`

export const ServiceTitle = styled.div`
    align-items: center;
    justify-content: space-between;
    display: flex;
    width: unset;
    gap: 16px;
`

export const Container = styled.div`
  ${({ gap }) => css`
    align-items: center;
    justify-content: space-between;
    display: flex;
    width: 100%;
    gap: ${gap || 0};

    @media screen and (max-width: 1200px) {
      width: unset;
      gap: 16px;
    }
  `}
   ${({ isServicePackage }) => isServicePackage && css`
    @media screen and ${MOBILE} {
      flex-direction: column;
    }
  `}
`

export const ServiceRadioContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  ${({ hasBorder }) => hasBorder && css`
    border-bottom: 1px solid var(--silver);
    padding-bottom: 16px;
  `}
`

export const ServiceDescription = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  align-self: flex-start;
  color: var(--gray-5);
  font-size: 1.4rem;
`

export const Photo = styled.div`
  ${({ size, src, setDefaultPhoto, mobileSize, isDoctorIcon }) => css`
    width: ${size || '40px'};
    height: ${isDoctorIcon ? '27px' : size || '40px'};
    border-radius: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background-image: url("${src}");
    background-size: ${setDefaultPhoto ? 'contain' : 'cover'};
    background-repeat: no-repeat;
    background-position: center center;
    ${({ borderRadiusNone }) => borderRadiusNone && css`
      border-radius: 0;
    `}
    @media screen and (max-width: 1200px) {
      width: ${mobileSize || '40px'};
      height: ${isDoctorIcon ? '27px' : size || '40px'};
      min-width: ${mobileSize || '40px'};
    }

  `}
`
export const Option = styled.div`
  right: 16px;
`
export const ServiceOption = styled(Option)`
  @media screen and ${DESKTOP_UP} {
    right: calc(50% - 20px);
    bottom: 24px;
  }
`

export const AllAdditionalCheckboxContainer = styled.div`
  ${Checkbox} {
    input:checked ~ label::before {
      background: var(--cobasi-blue-light-8);
    }
  }

  div {
    margin-top: 16px;
    label {
      color: var(--gray-5);
      font-family: var(--primary-font);
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 145%;
    }
  }
`

export const CheckList = styled.div`
  display: flex;
  max-width: 752px;
  margin: 24px 0px;
  flex-wrap: wrap;
  gap: 24px;
  position: relative;
`

export const AdditionalServices = styled(Card)`
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  align-items: center;
  padding: 8px 16px;
  border-radius: 16px;
  width: 100%;
  height: 60px;
  gap: 16px;
  background: var(--Color-Neutral-Basic-color-neutral-white, #FFF);
  border: 1px solid var(--silver);

  label {
    color: var(--Gray-gray-800, var(--Color-Neutral-Gray-color-gray-800, #444));
    font-family: "Montserrat";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.2px;
  }
`

export const QuantityControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: ${props => props.disabled ? 0.5 : 1};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 4px;
    background: none;
    cursor: pointer;
    transition: all 0.2s ease;
    padding: 0;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    img {
      width: 16px;
      height: 16px;
      filter: ${props => props.disabled ? 'invert(91%) sepia(0%) saturate(0%) hue-rotate(153deg) brightness(92%) contrast(86%)' : 'invert(47%) sepia(92%) saturate(463%) hue-rotate(152deg) brightness(92%) contrast(101%)'};
    }
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    align-self: stretch;
    width: 40px;
    height: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    color: #444444;
    border-radius: 8px;
    font-family: 'Montserrat';
    border: 1px solid var(--Color-Neutral-Gray-color-gray-500, #777);
    background: var(--Color-Neutral-Basic-color-neutral-white, #FFF);
  }
`

export const SelectionCircle = styled.div`
  width: 18px;
  height: 18px;
  border: 2px solid var(--Color-Neutral-Gray-color-gray-300, #CCC);
  border-radius: 50%;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  ${props => props.isChecked && `
    border-color: var(--Color-Primary-color-primary-500, #007AFF);
    &:after {
      content: '';
      width: 10px;
      height: 10px;
      background: var(--Color-Primary-color-primary-500, #007AFF);
      border-radius: 50%;
    }
  `}
`

export const RightControls = styled.div`
  display: flex;
  gap: 16px;
  margin-left: auto;
  justify-content: center;
  align-items: center;
`

export const TextareaContainer = styled.div`
  position: relative;
  margin-top: 24px;
  label {
    position: absolute;
    top: -12px;
    left: 14px;
    background-color: var(--the-white);
    color: var(--gray-5);
    font-family: var(--primary-font);
    font-size: 12px;
    line-height: 19.07px;
    padding: 4px;
    z-index: 1;
  }

  scroll-margin-top: 88px;

  @media screen and ${DESKTOP_UP} {
    max-width: 704px;
    width: 100%;
  }

  @media screen and (max-width: 1200px) {
    max-width: 100%;
    width: 100%;
  }

  @media screen and ${MOBILE} {
    :focus-within {
      padding-top: 8px;
      label {
        margin-top: 8px;
      }
    }
  }
`

export const ObsTextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 16px;
  color: var(--gray-7);
  font-family: var(--primary-font);
  font-size: 12px;
  font-weight: 400;
  line-height: 21.79px;
  border-color: var(--dim-gray);
  border-radius: 16px;
  ::placeholder {
    color: var(--gray-7);
    max-height: 108px;
  }
`

export const Counter = styled.div`
  text-align: end;
  font-family: var(--primary-font);
  font-size: 12px;
  font-weight: 400;
  color: var(--gray-7);
  margin-top: -4px;
  margin-right: 16px;
  line-height: normal;
`

export const TextInfo = styled.div`
  ${({ isService, isServicePackage }) => css`
    display: flex;
    flex-direction: column;
    gap: 4px;

    span:first-of-type {
      font-size: 16px;
      font-weight: 600;
      line-height: 19.2px;
      font-family: var(--primary-font);
    }

    span:last-of-type {
      font-size: 12px;
      font-weight: 400;
      line-height: 17.7px;
      font-family: var(--primary-font);
    }

    ${isService && css`
      span:last-of-type {
        font-size: 14px;
        color: var(--gray-2);
        font-weight: 600;
        line-height: 21px;

        text-align: center;

        @media screen and (max-width: 1200px) {
          margin: unset;
          text-align: start;
        }
      }
    `}

    color: var(--gray-2);

    ${isServicePackage && css`
      @media screen and ${MOBILE} {
        span:last-of-type {
          text-align: center;
          font-size: 14px;
        }
      }
    `}
  `}
`

export const PageContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;

  @media screen and (max-width: 1200px) {
    padding: 0 16px;
  }
`

export const AlignWrappers = styled.div`
  flex: 1;
  max-width: 1040px;
  margin-bottom: 24px;

  ${({ noMargin }) => noMargin && css`
    margin-bottom: 0;
  `}
`

export const WrapperForm = styled(AlignWrappers)`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  ${({ noMargin }) => noMargin && css`
    margin-bottom: 0;
  `}


  ${({ noMarginTop }) => noMarginTop && css`
    margin-top: 0;
  `}
`

export const NoPetData = styled.div`
  border: 1px solid var(--silver);
  padding: 16px;
  border-radius: 2.4rem;
  max-width: 754px;
`

export const WrapperElements = styled.div`
  display: flex;
  max-width: 754px;
  width: 100%;
  gap: 24px;
  flex-wrap: wrap;
  position: relative;

  @media screen and ${MOBILE} {
    gap: 24px;
  }
`

export const WrapperServices = styled.div`
  display: flex;
  max-width: 752px;
  margin-top: 24px;
  flex-wrap: wrap;
  gap: 24px;
  position: relative;

  @media screen and ${MOBILE} {
      gap: 16px;
      margin-bottom: 0;
  }

   ${({ packageServices }) => packageServices && css`
    @media screen and ${MOBILE} {
      margin: 0 auto 16px auto;
    }
  `}
`

export const WrapperAdditionalServices = styled.div`
  display: flex;
  flex-direction: column;
`

export const PetRegistration = styled.div`
  border-radius: 99px;
  border: 1px solid var(--cobasi-blue-light-9);
  padding: 8px 16px;
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 10px;
  height: 40px;
  font-size: 16px;
  line-height: normal;
  font-weight: 600;
  font-family: var(--primary-font);
  color: var(--cobasi-blue-light-9);

  :before {
    content: url('${assetPrefix}/static/icons/plus.svg');
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 8px;
  }

  :active {
    transition: 0.1s;
    opacity: 0.3;
  }

  :hover {
    transition: 0.3s;
    opacity: 0.8;
  }

  cursor: pointer;
`

export const WrapperAdditionalServicesAndObs = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

`

export const UseExistingPet = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  gap: 16px;
  flex: 1 0 0;
  color: var(--Gray-gray-900, var(--Color-Neutral-Gray-color-gray-900, #222));
  font-family: 'Montserrat';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`
export const PetNotFound = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--Spacing-Spacing-spacing-xxs, 16px);
  flex: 1 0 0;
`

export const PetNotFoundTitle = styled.div`
  color: var(--Color-Neutral-Gray-color-gray-900, #222);
  text-align: center;
  font-family: 'Montserrat';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
`

export const PetNotFoundTextInfo = styled.div`
  color: var(--Color-Neutral-Gray-color-gray-700, #555);
  text-align: center;
  font-family: 'Montserrat';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  align-self: stretch;
`

export const WrapperTitle = styled.div`
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: var(--gray-2);

  ${({ firstContainer }) => firstContainer && css`
    @media screen and (max-width: 1200px) {
      margin-top: 28px;
    }
  `}

  ${({ isServices }) => isServices && css`
    font-size: 16px;
    line-height: 19.2px;
    color: var(--gray-2);
  `}

  ${({ isPet }) => isPet && css`
    margin-bottom: 24px;
  `}

   ${({ isFlex }) => isFlex && css`
    display: flex;
    gap: 16px;
    align-items: center;
  `}

  @media screen and ${MOBILE} {
    font-size: 16px;
  }
`

export const SliderContainer = styled.div`
  .slick-track {
    display: flex;
    align-items: stretch;
  }

  .slide-inner {
    width: inherit;
    padding-right: 0 !important;
    border-radius: 8px;
    overflow: hidden;
  }

  .slick-slide{
    width: 132.67px !important;
    opacity: 0.32;
    transition: opacity 0.3s ease;
  }


   @media screen and (max-width: 600px) {
    .slick-slide {
      width: 164px !important;
      &:last-of-type {
        width: 140px !important;
      }
    }
  }

 .slick-active {
    opacity: 1;
  }

  width: 100%;
  .slick-dots {
    position: relative;
    bottom: 0;
    margin-top: 24px;

    li {
      width: 0px;
      height: 0px;
      margin: 0 10px;
    }

    li.slick-active button {
      max-width: 12px;
      max-height: 12px;
      border-radius: 50px;
      background: var(--Color-Primary-color-primary-800, #028BB7);
    }

    li button {
      max-width: 8px;
      max-height: 8px;
      border-radius: 50px;
      background: var(--Color-Neutral-Gray-color-gray-300, #DADADA);
      padding: 0px;
    }

    li button:before,
    li.slick-active button:before {
      color: unset !important;
    }
  }
`

export const DiscountTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 2px 8px;
  width: 120px;
  height: 24px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 8px;
  align-self: stretch;
  margin-bottom: 16px;
  background: var(--coral-orange-light);
  color: var(--coral-orange);

  @media screen and ${MOBILE} {
    margin-bottom: 8px;
  }

  ${({ additional }) => additional && css`
    align-self: center;
    margin-bottom: 0px !important;

    ${({ hideOnMobile }) => hideOnMobile && css`
      @media screen and ${MOBILE} {
        display: none;
      }
    `}

    ${({ hideOnDesktop }) => hideOnDesktop && css`
      @media screen and ${DESKTOP_UP} {
        display: none;
      }
    `}

  `}
`

export const PurchasedPackagesWrapper = styled.div`
  margin-bottom: 16px;

  @media screen and ${MOBILE} {
    margin-bottom: 0;
  }
`

export const SliderArrow = styled.button`
  &:before {
    content: '';
  }

  &.slick-next, &.slick-prev {
    width: 20px;
    height: 20px;
    font-size: 0;
    line-height: 0;
    position: absolute;
    top: -42px;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: none;
    background: transparent;
  }

  &.slick-next {
    right: -24px;
  }

  &.slick-prev {
    left: unset;
    right: 16px;
  }
`

const SliderArrowStyles = css`
  font-size: 21px;
  color: var(--gray-7);

  &:hover {
    color: var(--cobasi-blue);
  }
`

export const SliderNextArrow = styled(ChevronRight)`
  ${SliderArrowStyles}
`

export const SliderPrevArrow = styled(ChevronRight)`
  transform: rotate(180deg);
  ${SliderArrowStyles}
`
